import React, { Fragment } from 'react';
import { Divider } from '../common/Divider';

interface OperationSettlementSummaryStatementCardProps {
  testId?: string;
  className?: string;
  title?: string;
  data: Array<{ field: string; value: string; unit: string }>;
}

export const OperationSettlementSummaryStatementCard: React.FC<
  OperationSettlementSummaryStatementCardProps
> = ({ testId, className, title, data }) => {
  return (
    <div
      data-testid={testId}
      className={`rounded-[5px] bg-light-2 p-5 ${className}`}
    >
      <p className="noto-11-semibold leading-none text-dark-6">{title}</p>
      {data.map(({ field, value, unit }, index, array) => {
        const isLastIndex = index === array.length - 1;

        return (
          <Fragment key={index}>
            {isLastIndex && <Divider className="mt-4 bg-dark-3" />}
            <div className="mt-4 flex w-full">
              <span
                className={`${isLastIndex ? 'noto-13-light' : 'noto-11-light'} leading-none text-dark-6`}
              >
                {field}
              </span>
              <span
                className={`${isLastIndex ? 'noto-13-semibold' : 'noto-11-semibold'} ml-auto leading-none text-dark-6`}
              >
                {value}
              </span>
              <span
                className={`${isLastIndex ? 'noto-13-semibold' : 'noto-11-semibold'} ml-[3px] leading-none text-dark-6`}
              >
                {unit}
              </span>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
